import { Injectable } from '@angular/core';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CopyToService {
    public static $name = 'copyToService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public copyScheduleToSelectedRTUs(copyFromId: number, copyToIds: string[]): angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'hardware', route: 'copyScheduleToSelectedRTUs',
            routeParams: {
                sourceHardwareItemId: copyFromId
            },
            data: copyToIds
        }).asNoContent();
    }
}
